import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/download/sec6_phone2.png'
import _imports_1 from '@/assets/img/download/sec6_phone1.png'


const _hoisted_1 = { class: "max-w-4xl mx-auto flex flex-col sm:flex-row w-[896px]:px-0 px-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto lg:mt-0 mt-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "-translate-x-0 sm:-translate-x-12"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium leading-relaxed text-lg sm:text-xl sm:leading-relaxed text-[#3E4044] text-center sm:text-left lg:self-end self-auto" }, [
  /*#__PURE__*/_createTextVNode("등록한 개체 카드를 자랑하고 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 전송할 수 있어요."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 거래하고 개체 정보를 편리하게 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 공유해보세요.")
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBox = _resolveComponent("TitleBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-full sm:w-1/2 transition-all duration-1000 opacity-0", _ctx.elClass]),
      ref: "elRef"
    }, [
      _createVNode(_component_TitleBox, {
        title: "채팅",
        content1: "개체 정보 카드를",
        content2: "구매자에게 전달하기"
      }),
      _hoisted_2
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["w-full sm:w-1/2 h-full flex flex-col justify-between transition-all duration-1000 opacity-0 delay-300", _ctx.elClass])
    }, _hoisted_5, 2)
  ]))
}